import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { categoryOrganizationOptions } from "../../components/Admin/Scheduling/categoryOrganizations";

// Resolve eligible descendants without changing the caller's organization selection.
export function useCategoryOrganizations(context) {
  const { isSuperAdmin, organizationRef, organizations, excludedOrganizationRefs, orgOptions, orgsLoading } = context;
  const query = useQuery(
    ["category-owner-organizations", organizationRef, excludedOrganizationRefs],
    async () => {
      const response = await axios.get("organization", { params: { orgId: organizationRef, active: true } });
      if (!Array.isArray(response?.data)) throw new Error("Could not load organizations.");
      return response.data;
    },
    { enabled: !isSuperAdmin && !!organizationRef, staleTime: 0, refetchOnWindowFocus: false, retry: false }
  );
  const root = organizations.find(org => org.id === organizationRef);
  return {
    organizations: query.data,
    options: isSuperAdmin ? orgOptions : categoryOrganizationOptions(root, query.data || [], excludedOrganizationRefs),
    isLoading: orgsLoading || (!isSuperAdmin && query.isLoading),
    isError: context.orgsError || (!isSuperAdmin && query.isError),
    retry: () => { context.refetchOrgs?.(); if (!isSuperAdmin) query.refetch(); },
  };
}
